import { useEffect, useState } from "react";
import { fetchProducts } from "@/lib/api";

// Module-level cache so multiple tool pages don't refetch.
let _cache = null;
let _inflight = null;

export const useProducts = () => {
  const [products, setProducts] = useState(_cache || []);
  const [loading, setLoading] = useState(!_cache);

  useEffect(() => {
    if (_cache) return;
    let cancelled = false;
    if (!_inflight) _inflight = fetchProducts();
    _inflight
      .then((data) => {
        _cache = data;
        if (!cancelled) {
          setProducts(data);
          setLoading(false);
        }
      })
      .catch(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { products, loading };
};
